// extracted by mini-css-extract-plugin
export default {"imageContainer":"DisplayFoodContainer_imageContainer__FjPUu"};